export default "__VITE_ASSET__DUa4onuN__"